import { stickerPackStore } from '../store/stickerPack';
import { useStore } from './useStore';

export function useStickerPacks() {
  const stickerPacks = useStore(stickerPackStore);

  return {
    stickerPacks,
  };
}
